import React, { useState } from 'react';
import { Card } from './ui/Card';
import { Button } from './ui/Button';
import { CheckCircleIcon } from 'lucide-react';
import { useEvent } from '../contexts/EventContext';
import { useAuth } from '../contexts/AuthContext';
import { EventType } from '../types';
interface EventPreferenceProps {
  onBack: () => void;
}
export function EventPreference({
  onBack
}: EventPreferenceProps) {
  const {
    currentEvent,
    allEvents,
    switchEvent
  } = useEvent();
  const {
    updateProfile
  } = useAuth();
  const [selectedEvent, setSelectedEvent] = useState<EventType>(currentEvent.id);
  const handleSave = () => {
    switchEvent(selectedEvent);
    updateProfile({
      defaultEvent: selectedEvent
    });
    onBack();
  };
  return <div className="pb-24" data-id="element-3377">
      <div className="p-4" data-id="element-3378">
        <p className="text-gray-600 font-gotham mb-4" data-id="element-3379">
          Select which event you'd like to see by default. You can switch
          between events anytime from the menu.
        </p>

        <div className="space-y-3" data-id="element-3380">
          {allEvents.map(event => <button key={event.id} onClick={() => setSelectedEvent(event.id)} className={`w-full text-left p-4 rounded-lg border-2 transition-all ${selectedEvent === event.id ? 'border-gray-900 bg-gray-50' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-3381">
              <div className="flex items-start justify-between" data-id="element-3382">
                <div className="flex-1" data-id="element-3383">
                  <div className="flex items-center gap-2 mb-1" data-id="element-3384">
                    <h3 className="font-bold text-gray-900 font-gotham" data-id="element-3385">
                      {event.name}
                    </h3>
                    {event.id === currentEvent.id && <span className="text-xs px-2 py-0.5 rounded-full bg-blue-100 text-blue-700 font-gotham font-medium" data-id="element-3386">
                        Current
                      </span>}
                  </div>
                  <p className="text-sm text-gray-600 font-gotham mb-2" data-id="element-3387">
                    {event.description}
                  </p>
                  <p className="text-xs text-gray-500 font-gotham" data-id="element-3388">
                    {event.dates}
                  </p>
                </div>
                {selectedEvent === event.id && <CheckCircleIcon className="w-6 h-6 text-gray-900 flex-shrink-0 ml-3" data-id="element-3389" />}
              </div>
            </button>)}
        </div>

        <div className="mt-6" data-id="element-3390">
          <Button variant="primary" fullWidth onClick={handleSave} disabled={selectedEvent === currentEvent.id} data-id="element-3391">
            {selectedEvent === currentEvent.id ? 'Already Selected' : 'Save Preference'}
          </Button>
        </div>
      </div>
    </div>;
}